import type { SVGAttributes } from 'react'

interface CircularProgressBarProps extends SVGAttributes<SVGSVGElement> {
	progress: number
	size?: number
	strokeWidth?: number
	color?: string
}

export const CircularProgressBar = ({
	progress,
	size = 48,
	strokeWidth = 8,
	...rest
}: CircularProgressBarProps) => {
	const radius = (size - strokeWidth) / 2
	const circumference = 2 * Math.PI * radius
	const offset = circumference - (progress / 100) * circumference
	return (
		<svg
			aria-label='Upload progress'
			className='-rotate-90'
			height={size}
			role='img'
			width={size}
			{...rest}
		>
			<circle
				className='stroke-neutral-300'
				cx={size / 2}
				cy={size / 2}
				fill='none'
				r={radius}
				strokeWidth={strokeWidth}
			/>
			<circle
				className='stroke-danger-600'
				cx={size / 2}
				cy={size / 2}
				fill='none'
				r={radius}
				strokeDasharray={circumference}
				strokeDashoffset={offset}
				strokeWidth={strokeWidth}
				style={{ transition: 'stroke-dashoffset 0.1s ease-in-out' }}
			/>
		</svg>
	)
}
